import React from 'react';
import { getSystemMessageIcon, formatMessageTime } from '../../utils/chatUtils';

const SystemMessage = ({ message, showTimestamp = true }) => {
  const icon = getSystemMessageIcon(message.message_type, message.message);
  
  // Check if message already starts with an emoji (to avoid duplicate icons)
  const messageStartsWithEmoji = /^[\u{1F300}-\u{1F9FF}]|^[📅✏️🎯✅❌📋]/u.test(message.message);
  
  return (
    <div className="flex justify-center my-4">
      <div className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-2 max-w-md">
        <div className="flex items-center justify-center text-sm text-gray-600">
          {!messageStartsWithEmoji && <span className="mr-2 text-base">{icon}</span>}
          <span className="text-center">
            {message.message}
          </span>
        </div>
        {showTimestamp && (
          <div className="text-xs text-gray-400 text-center mt-1">
            {formatMessageTime(message.created_at)}
          </div>
        )}
      </div>
    </div>
  );
};

export default SystemMessage;
